export const studentsConstants = {
    SHOW_STUDENT : 'SHOW_STUDENT',
    UPDATE_STUDENT: 'UPDATE_STUDENT',
    UPDATE_IMAGE_PROFILE: 'UPDATE_IMAGE_PROFILE',
    UPDATE_RELATIVE: 'UPDATE_RELATIVE',

    MY_EVALUATIONS: 'MY_EVALUATIONS',
    STUDENT_REMOVE_RELATED: 'STUDENT_REMOVE_RELATED',
    STUDENT_ADD_RELATED: 'STUDENT_ADD_RELATED',
    COURSE_EVALUATIONS: 'COURSE_EVALUATIONS',

    STUDENT_ATTENDANCE: 'STUDENT_ATTENDANCE'

};